<template>
    <div>
        <h1 class="display-heading">{{pageTitle}}</h1>

        <!-- #region Create -->
        <div class="bs-stepper" v-if="isAddTier">
            <div class="bs-stepper-header" role="tablist">
                <div class="step" data-target="#tier-name">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                            aria-controls="tier-name"
                            id="tier-name-trigger"
                        >
                            <span class="bs-stepper-circle">1</span>
                            <span class="bs-stepper-label">Tier Name</span>
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#benefits-coverage">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                            aria-controls="benefits-coverage"
                            id="benefits-coverage-trigger"
                        >
                            <span class="bs-stepper-circle">2</span>
                            <span class="bs-stepper-label"
                                >Benefits Coverage</span
                            >
                        </button>
                    </div>
                    <div class="line"></div>
                    <div class="step" data-target="#financial-limit">
                        <button
                            type="button"
                            class="step-trigger"
                            role="tab"
                            aria-controls="financial-limit"
                            id="financial-limit-trigger"
                        >
                            <span class="bs-stepper-circle">3</span>
                            <span class="bs-stepper-label"
                                >Financial Limits</span
                            >
                        </button>
                    </div>
            </div>
            <div class="bs-stepper-content">
                <!-- your steps content here -->
                    <div
                        id="tier-name"
                        class="content"
                        role="tabpanel"
                        aria-labelledby="tier-name-trigger"

                    >
                        <div class="form-group">
                            <label><b>What is the tier's name?</b></label>
                            <input type="text" placeholder="Tier Name" name="tierName" v-model="form.tn"
                                data-vv-as="tier name" data-vv-validate-on="blur"
                                v-validate="'required'" :class="{
                                    'form-control': true,
                                    'is-invalid':  validationErrors.has('tierName')
                                }">
                            <div v-show="validationErrors.has('tierName')"
                                class="invalid-feedback">
                                {{ validationErrors.first('tierName') }}
                            </div>
                        </div>

                        <!-- Next Button -->
                        <button
                            @click="nextStep(1)"
                            class="btn btn-primary btn-primary-insv"
                        >
                            Next
                        </button>
                    </div>

                    <div
                        id="benefits-coverage"
                        class="content"
                        role="tabpanel"
                        aria-labelledby="benefits-coverage-trigger"
                    >
                        <p><b>What benefits does this tier have?</b></p>
                        <div>
                            <!-- Employee Benefit -->
                            <!-- <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.pfbc">
                                        <div class="ml-2" style="margin-top:-3px">Full Employee Benefits</div>
                                    </label>
                                </div>
                            </div> -->
                            <div class="mb-2" v-if="!form.pfbc">
                                <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="showCoverage(0)">Set Employee Benefits</button>
                            </div>

                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.hfl">
                                        <div class="ml-2" style="margin-top:-3px">Shared Family Limit</div>
                                        <i class="ml-2 fas fa-question-circle fa-sx" data-toggle="tooltip" :title="getFamilyBenefitLabel()"></i>
                                    </label>
                                </div>
                            </div>

                            <!-- Spouse Benefit -->
                            <div class="mb-3">
                                    <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.sb">
                                        <div class="ml-2" style="margin-top:-3px">Spouse Benefit</div>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group ml-5" v-if="form.sb">
                                <div class="d-flex align-items-baseline">
                                    <button :disabled="form.supbc" class="btn btn-primary btn-primary-insv mr-2" type="button" @click="showCoverage(1)">Set Spouse Benefits</button>
                                    <div class="form-check">
                                        <label class="form-check-label d-flex">
                                            <input class="form-check-input" type="checkbox" v-model="form.supbc">
                                            <div class="ml-2">Same as Principal Employee Benefits</div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <!-- Dependent Benefit -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.db">
                                        <div class="ml-2">Dependent Benefit</div>
                                    </label>
                                </div>
                            </div>

                            <div class="form-group ml-5" v-if="form.db">
                                <div class="d-flex align-items-baseline">
                                    <button :disabled="form.dupbc" class="btn btn-primary btn-primary-insv mr-2" type="button" @click="showCoverage(2)">Set Dependent Benefits</button>
                                    <div class="form-check">
                                        <label class="form-check-label d-flex">
                                            <input class="form-check-input" type="checkbox" v-model="form.dupbc">
                                            <div class="ml-2">Same as Principal Employee Benefits</div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p v-if="shouldShowSubmitMessage"
                            :class="{
                                'text-danger': submitHasError
                            }">
                            {{submitMessage}}
                        </p>

                        <!-- Back Button -->
                        <button
                            @click="previousStep"
                            class="btn btn-secondary"
                        >
                            Previous
                        </button>

                        <!-- Next Button -->
                        <button
                            @click="nextStep(2)"
                            class="btn btn-primary btn-primary-insv ml-2"
                        >
                            Next
                        </button>
                    </div>

                    <div
                        id="financial-limit"
                        class="content"
                        role="tabpanel"
                        aria-labelledby="financial-limit-trigger"
                    >
                        <p><b>What financial limits should be imposed on this tier?</b></p>
                        <form data-vv-scope="tier" @submit.prevent="saveChanges">
                            <!-- Employee Annual Benefit Limit -->
                            <div class="form-group">
                                <label>Employee Annual Benefit Limit</label>
                                <input type="number" step=".01" placeholder="0.00" name="employeeSpendingLimit" v-model="form.esl"
                                    data-vv-as="employee spending limit" data-vv-validate-on="blur"
                                    v-validate="'required|decimal:2|min_value:0.00'"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('tier.employeeSpendingLimit')
                                    }">
                                <div v-show="validationErrors.has('tier.employeeSpendingLimit')"
                                    class="invalid-feedback">
                                    {{ validationErrors.first('tier.employeeSpendingLimit') }}
                                </div>
                            </div>

                            <!-- Spouse Annual Benefit Limit -->
                            <div class="form-group" v-if="form.sb && !form.hfl">
                                <label>Spouse Annual Benefit Limit</label>
                                <input type="number" step=".01" placeholder="0.00" name="spouseSpendingLimit" v-model="form.ssl"
                                    data-vv-as="spouse spending limit" data-vv-validate-on="blur"
                                    :disabled="form.hfl" v-validate="!form.hfl ? 'required|decimal:2|min_value:0.01' : ''"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('tier.spouseSpendingLimit')
                                    }">
                                <div v-show="validationErrors.has('tier.spouseSpendingLimit')"
                                    class="invalid-feedback">
                                    {{ validationErrors.first('tier.spouseSpendingLimit') }}
                                </div>
                            </div>

                            <!-- Dependent Annual Benefit Limit -->
                            <div class="form-group" v-if="form.db && !form.hfl">
                                <label>Child(ren) Annual Limit</label>
                                <input type="number" step=".01" placeholder="0.00" name="dependentSpendingLimit" v-model="form.dsl"
                                    data-vv-as="dependent spending limit" data-vv-validate-on="blur"
                                    :disabled="form.hfl" v-validate="!form.hfl ? 'required|decimal:2|min_value:0.01' : ''"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('tier.dependentSpendingLimit')
                                    }">
                                <div v-show="validationErrors.has('tier.dependentSpendingLimit')"
                                    class="invalid-feedback">
                                    {{ validationErrors.first('tier.dependentSpendingLimit') }}
                                </div>
                            </div>

                            <!-- Check box instructions -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <div class="text-danger" style="margin-top:-3px">Check boxes if applicable</div>
                                    </label>
                                </div>
                            </div>

                            <!-- Employee Monthly Transaction Limit -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.hemtl">
                                        <div class="ml-2" style="margin-top:-3px">Employee Monthly Transaction Limit</div>
                                    </label>
                                </div>
                            </div>

                            <div v-if="form.hemtl" class="form-group">
                                <!-- <label>Employee Monthly Transaction Limit</label> -->
                                <input type="number" step=".01" placeholder="0.00" name="employeeMonthlyTransactionLimit" v-model="form.emtl"
                                    data-vv-as="employee monthly transaction limit" data-vv-validate-on="blur"
                                    :disabled="!form.hemtl" v-validate="form.hemtl ? 'required|decimal:2|min_value:0.00' : ''"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('tier.employeeMonthlyTransactionLimit')
                                    }">
                                <div v-show="validationErrors.has('tier.employeeMonthlyTransactionLimit')"
                                    class="invalid-feedback">
                                    {{ validationErrors.first('tier.employeeMonthlyTransactionLimit') }}
                                </div>
                            </div>

                            <!-- Employee Weekly Transaction Limit -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.hewtl">
                                        <div class="ml-2" style="margin-top:-3px">Employee Weekly Transaction Limit</div>
                                    </label>
                                </div>
                            </div>

                            <div v-if="form.hewtl" class="form-group">
                                <!-- <label>Employee Weekly Transaction Limit</label> -->
                                <input type="number" step=".01" placeholder="0.00" name="employeeWeeklyTransactionLimit" v-model="form.ewtl"
                                    data-vv-as="employee weekly transaction limit" data-vv-validate-on="blur"
                                    :disabled="!form.hewtl" v-validate="form.hewtl ? 'required|decimal:2|min_value:0.00' : ''"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('tier.employeeWeeklyTransactionLimit')
                                    }">
                                <div v-show="validationErrors.has('tier.employeeWeeklyTransactionLimit')"
                                    class="invalid-feedback">
                                    {{ validationErrors.first('tier.employeeWeeklyTransactionLimit') }}
                                </div>
                            </div>

                            <!-- Employee Clinic Consultation Transaction Limit -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.hecctl">
                                        <div class="ml-2" style="margin-top:-3px">Employee Clinic Consultation Transaction Limit</div>
                                    </label>
                                </div>
                            </div>

                            <div v-if="form.hecctl" class="form-group">
                                <!-- <label>Employee Clinic Consultation Transaction Limit</label> -->
                                <input type="number" step=".01" placeholder="0.00" name="employeeClinicConsultationTransactionLimit" v-model="form.ecctl"
                                    data-vv-as="employee clinic consultation transaction limit" data-vv-validate-on="blur"
                                    :disabled="!form.hecctl" v-validate="form.hecctl ? 'required|decimal:2|min_value:0.00' : ''"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('tier.employeeClinicConsultationTransactionLimit')
                                    }">
                                <div v-show="validationErrors.has('tier.employeeClinicConsultationTransactionLimit')"
                                    class="invalid-feedback">
                                    {{ validationErrors.first('tier.employeeClinicConsultationTransactionLimit') }}
                                </div>
                            </div>

                            <!-- Requires Clinic Co-Payment/Co-Pay -->
                            <div class="mb-3">
                                <div class="form-check">
                                    <label class="form-check-label d-flex">
                                        <input class="form-check-input" type="checkbox" v-model="form.henca">
                                        <div class="ml-2" style="margin-top:-3px">Requires Clinic Co-Payment/Co-Pay</div>
                                        <i class="ml-2 fas fa-question-circle fa-sx" data-toggle="tooltip" :title="getCoPaymentLabel()"></i>
                                    </label>
                                </div>
                            </div>

                            <div v-if="form.henca" class="form-group">
                                <label>Clinic Co-Payment/Co-Pay Amount</label>
                                <input type="number" step=".01" placeholder="0.00" name="employeeNonClaimableAmount" v-model="form.enca"
                                    data-vv-as="employee non claimable amount" data-vv-validate-on="blur"
                                    :disabled="!form.henca" v-validate="form.henca ? 'required|decimal:2|min_value:0.00' : ''"
                                    :class="{
                                        'form-control': true,
                                        'is-invalid':  validationErrors.has('tier.employeeNonClaimableAmount')
                                    }">
                                <div v-show="validationErrors.has('tier.employeeNonClaimableAmount')"
                                    class="invalid-feedback">
                                    {{ validationErrors.first('tier.employeeNonClaimableAmount') }}
                                </div>
                            </div>

                            <!-- Back Button -->
                            <button
                                @click="previousStep"
                                class="btn btn-secondary btn-primary-insv"
                            >
                                Previous
                            </button>

                            <!-- Submit Button -->
                            <button
                                type="submit"
                                class="btn btn-primary btn-primary-insv ml-2"
                            >
                                Submit
                            </button>
                        </form>
                    </div>
            </div>
        </div>
        <!-- #endregion -->

        <!-- #region Update -->
        <div v-else>
            <form data-vv-scope="tier" @submit.prevent="validateTierForm">
                <!-- Tier Name -->
                <div class="form-group">
                    <label><h5><b>Tier Name</b></h5></label>
                    <input type="text" placeholder="Tier Name" name="tierName" v-model="form.tn"
                        data-vv-as="tier name" data-vv-validate-on="blur"
                        v-validate="'required'" :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tierName')
                        }">
                    <div v-show="validationErrors.has('tierName')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tierName') }}
                    </div>
                </div>

                <!-- Benefits Coverage -->
                <h5 class="pb-2 pt-3"><b>Benefits Coverage</b></h5>

                <!-- Employee Benefit -->
                <!-- <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.pfbc">
                            <div class="ml-2" style="margin-top:-3px">Full Employee Benefits</div>
                        </label>
                    </div>
                </div> -->
                <div class="mb-2" v-if="!form.pfbc">
                    <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="showCoverage(0)">Set Employee Benefits</button>
                </div>

                <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.hfl">
                            <div class="ml-2" style="margin-top:-3px">Shared Family Limit</div>
                            <i class="ml-2 fas fa-question-circle fa-sx" data-toggle="tooltip" :title="getFamilyBenefitLabel()"></i>
                        </label>
                    </div>
                </div>

                <!-- Spouse Benefit -->
                <div class="mb-3">
                        <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.sb">
                            <div class="ml-2" style="margin-top:-3px">Spouse Benefit</div>
                        </label>
                    </div>
                </div>

                <div class="form-group ml-5" v-if="form.sb">
                    <div class="d-flex align-items-baseline">
                        <button :disabled="form.supbc" class="btn btn-primary btn-primary-insv mr-2" type="button" @click="showCoverage(1)">Set Spouse Benefits</button>
                        <div class="form-check">
                            <label class="form-check-label d-flex">
                                <input class="form-check-input" type="checkbox" v-model="form.supbc">
                                <div class="ml-2">Same as Principal Employee Benefits</div>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Dependent Benefit -->
                <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.db">
                            <div class="ml-2">Dependent Benefit</div>
                        </label>
                    </div>
                </div>

                <div class="form-group ml-5" v-if="form.db">
                    <div class="d-flex align-items-baseline">
                        <button :disabled="form.dupbc" class="btn btn-primary btn-primary-insv mr-2" type="button" @click="showCoverage(2)">Set Dependent Benefits</button>
                        <div class="form-check">
                            <label class="form-check-label d-flex">
                                <input class="form-check-input" type="checkbox" v-model="form.dupbc">
                                <div class="ml-2">Same as Principal Employee Benefits</div>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Finacial Limits -->
                <h5 class="pb-2 pt-3"><b>Financial Limits</b></h5>

                <!-- Employee Annual Benefit Limit -->
                <div class="form-group">
                    <label>Employee Annual Benefit Limit</label>
                    <input type="number" step=".01" placeholder="0.00" name="employeeSpendingLimit" v-model="form.esl"
                        data-vv-as="employee spending limit" data-vv-validate-on="blur"
                        v-validate="'required|decimal:2|min_value:0.00'"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tier.employeeSpendingLimit')
                        }">
                    <div v-show="validationErrors.has('tier.employeeSpendingLimit')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tier.employeeSpendingLimit') }}
                    </div>
                </div>

                <!-- Spouse Annual Benefit Limit -->
                <div class="form-group" v-if="form.sb && !form.hfl">
                    <label>Spouse Annual Benefit Limit</label>
                    <input type="number" step=".01" placeholder="0.00" name="spouseSpendingLimit" v-model="form.ssl"
                        data-vv-as="spouse spending limit" data-vv-validate-on="blur"
                        :disabled="form.hfl" v-validate="!form.hfl ? 'required|decimal:2|min_value:0.01' : ''"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tier.spouseSpendingLimit')
                        }">
                    <div v-show="validationErrors.has('tier.spouseSpendingLimit')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tier.spouseSpendingLimit') }}
                    </div>
                </div>

                <!-- Dependent Annual Benefit Limit -->
                <div class="form-group" v-if="form.db && !form.hfl">
                    <label>Child(ren) Annual Limit</label>
                    <input type="number" step=".01" placeholder="0.00" name="dependentSpendingLimit" v-model="form.dsl"
                        data-vv-as="dependent spending limit" data-vv-validate-on="blur"
                        :disabled="form.hfl" v-validate="!form.hfl ? 'required|decimal:2|min_value:0.01' : ''"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tier.dependentSpendingLimit')
                        }">
                    <div v-show="validationErrors.has('tier.dependentSpendingLimit')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tier.dependentSpendingLimit') }}
                    </div>
                </div>

                <!-- Check box instructions -->
                <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <div class="text-danger" style="margin-top:-3px">Check boxes if applicable</div>
                        </label>
                    </div>
                </div>

                <!-- Employee Monthly Transaction Limit -->
                <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.hemtl">
                            <div class="ml-2" style="margin-top:-3px">Employee Monthly Transaction Limit</div>
                        </label>
                    </div>
                </div>

                <div v-if="form.hemtl" class="form-group">
                    <!-- <label>Employee Monthly Transaction Limit</label> -->
                    <input type="number" step=".01" placeholder="0.00" name="employeeMonthlyTransactionLimit" v-model="form.emtl"
                        data-vv-as="employee monthly transaction limit" data-vv-validate-on="blur"
                        :disabled="!form.hemtl" v-validate="form.hemtl ? 'required|decimal:2|min_value:0.00' : ''"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tier.employeeMonthlyTransactionLimit')
                        }">
                    <div v-show="validationErrors.has('tier.employeeMonthlyTransactionLimit')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tier.employeeMonthlyTransactionLimit') }}
                    </div>
                </div>

                <!-- Employee Weekly Transaction Limit -->
                <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.hewtl">
                            <div class="ml-2" style="margin-top:-3px">Employee Weekly Transaction Limit</div>
                        </label>
                    </div>
                </div>

                <div v-if="form.hewtl" class="form-group">
                    <!-- <label>Employee Weekly Transaction Limit</label> -->
                    <input type="number" step=".01" placeholder="0.00" name="employeeWeeklyTransactionLimit" v-model="form.ewtl"
                        data-vv-as="employee weekly transaction limit" data-vv-validate-on="blur"
                        :disabled="!form.hewtl" v-validate="form.hewtl ? 'required|decimal:2|min_value:0.00' : ''"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tier.employeeWeeklyTransactionLimit')
                        }">
                    <div v-show="validationErrors.has('tier.employeeWeeklyTransactionLimit')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tier.employeeWeeklyTransactionLimit') }}
                    </div>
                </div>

                <!-- Employee Clinic Consultation Transaction Limit -->
                <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.hecctl">
                            <div class="ml-2" style="margin-top:-3px">Employee Clinic Consultation Transaction Limit</div>
                        </label>
                    </div>
                </div>

                <div v-if="form.hecctl" class="form-group">
                    <!-- <label>Employee Clinic Consultation Transaction Limit</label> -->
                    <input type="number" step=".01" placeholder="0.00" name="employeeClinicConsultationTransactionLimit" v-model="form.ecctl"
                        data-vv-as="employee clinic consultation transaction limit" data-vv-validate-on="blur"
                        :disabled="!form.hecctl" v-validate="form.hecctl ? 'required|decimal:2|min_value:0.00' : ''"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tier.employeeClinicConsultationTransactionLimit')
                        }">
                    <div v-show="validationErrors.has('tier.employeeClinicConsultationTransactionLimit')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tier.employeeClinicConsultationTransactionLimit') }}
                    </div>
                </div>

                <!-- Requires Clinic Co-Payment/Co-Pay -->
                <div class="mb-3">
                    <div class="form-check">
                        <label class="form-check-label d-flex">
                            <input class="form-check-input" type="checkbox" v-model="form.henca">
                            <div class="ml-2" style="margin-top:-3px">Requires Clinic Co-Payment/Co-Pay</div>
                            <i class="ml-2 fas fa-question-circle fa-sx" data-toggle="tooltip" :title="getCoPaymentLabel()"></i>
                        </label>
                    </div>
                </div>

                <div v-if="form.henca" class="form-group">
                    <label>Clinic Co-Payment/Co-Pay Amount</label>
                    <input type="number" step=".01" placeholder="0.00" name="employeeNonClaimableAmount" v-model="form.enca"
                        data-vv-as="employee non claimable amount" data-vv-validate-on="blur"
                        :disabled="!form.henca" v-validate="form.henca ? 'required|decimal:2|min_value:0.00' : ''"
                        :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('tier.employeeNonClaimableAmount')
                        }">
                    <div v-show="validationErrors.has('tier.employeeNonClaimableAmount')"
                        class="invalid-feedback">
                        {{ validationErrors.first('tier.employeeNonClaimableAmount') }}
                    </div>
                </div>

                <p v-if="shouldShowSubmitMessage"
                    :class="{
                        'text-danger': submitHasError
                    }">
                    {{submitMessage}}
                </p>
                <div>
                    <button class="btn btn-primary btn-primary-insv mr-2 mb-2" type="button" @click="saveChanges" :disabled="isSaving">Save</button>
                    <router-link v-if="isAddTier" class="btn btn-secondary mb-2" :to="{'name': 'tier-list'}">Cancel</router-link>
                </div>
            </form>
        </div>
        <!-- #endregion -->

        <!-- #region Pop Ups -->
        <!-- Principal Coverage -->
        <popup-modal ref="popupModalPrincipalCoverage" :hasCloseButton="true" :title="'Principal Employee Benefits'">
            <template slot="content">
                <permissible v-model="form.pbc" :viewOnly="false" :uniqueIdentifier="1"></permissible>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="$refs.popupModalPrincipalCoverage.hide()">Confirm</button>
                    <button class="btn btn-secondary" type="button" @click="cancelCoverage (0)">Cancel</button>
                </div>
            </template>
        </popup-modal>

        <!-- Spouse Coverage -->
        <popup-modal ref="popupModalSpouseCoverage" :hasCloseButton="true" :title="'Spouse Benefits'">
            <template slot="content">
                <permissible v-model="form.sbc" :viewOnly="false" :uniqueIdentifier="2"></permissible>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="$refs.popupModalSpouseCoverage.hide()">Confirm</button>
                    <button class="btn btn-secondary" type="button" @click="cancelCoverage (1)">Cancel</button>
                </div>
            </template>
        </popup-modal>

        <!-- Dependent Coverage -->
        <popup-modal ref="popupModalDependentCoverage" :hasCloseButton="true" :title="'Dependent Benefits'">
            <template slot="content">
                <permissible v-model="form.dbc" :viewOnly="false" :uniqueIdentifier="3"></permissible>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="$refs.popupModalDependentCoverage.hide()">Confirm</button>
                    <button class="btn btn-secondary" type="button" @click="cancelCoverage (2)">Cancel</button>
                </div>
            </template>
        </popup-modal>
        <!--#endregion -->
    </div>
</template>

<script>
import $ from 'jquery';
import {
    mask
} from 'vue-the-mask';
import popupModal from '@/components/popup-modal';
import permissible from '@/components/permissible';
import _ from 'lodash';
import Stepper from 'bs-stepper';
export default {
    'name': '',
    'directives': {
        mask
    },
    'components': {
        popupModal,
        permissible
    },
    'computed': {
        tierId () {
            return this.$route.name === 'tier-detail' ? this.$route.params.id : null;
        },
        isAddTier () {
            return this.$route.name === 'tier-detail-add';
        },
        pageTitle () {
            return this.isAddTier ? 'Add New Tier' : 'View / Edit Tier Details';
        },
        shouldShowSubmitMessage () {
            return this.submitMessage ? this.submitMessage.length > 0 : false;
        }
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        if (!this.isAddTier && this.tierId) {
            this.axios.get('Tier/GetTierDetails', {
                'params': {
                    'tierId': this.tierId
                }
            }).then(({
                data
            }) => {
                let tierData = data.data;
                this.form.ti = tierData.ti;
                this.form.tn = tierData.tn;
                // this.form.rld = convertDateToDDMMYYYY(tierData.rld);
                this.form.esl = tierData.esl.toFixed(2);
                this.form.hemtl = tierData.hemtl;
                this.form.emtl = tierData.emtl.toFixed(2);
                this.form.hewtl = tierData.hewtl;
                this.form.ewtl = tierData.ewtl.toFixed(2);
                this.form.hetctl = tierData.hetctl;
                this.form.etctl = tierData.etctl.toFixed(2);
                this.form.hetptl = tierData.hetptl;
                this.form.etptl = tierData.etptl.toFixed(2);
                this.form.hecctl = tierData.hecctl;
                this.form.ecctl = tierData.ecctl.toFixed(2);
                this.form.henca = tierData.henca;
                this.form.enca = tierData.enca.toFixed(2);
                this.form.hfl = tierData.hfl;
                // this.form.idsl = tierData.idsl;
                this.form.dsl = tierData.dsl.toFixed(2);
                this.form.hdmtl = tierData.hdmtl;
                this.form.dmtl = tierData.dmtl.toFixed(2);
                this.form.hdwtl = tierData.hdwtl;
                this.form.dwtl = tierData.dwtl.toFixed(2);
                this.form.hdtctl = tierData.hdtctl;
                this.form.dtctl = tierData.dtctl.toFixed(2);
                this.form.hdtptl = tierData.hdtptl;
                this.form.dtptl = tierData.dtptl.toFixed(2);
                this.form.hdcctl = tierData.hdcctl;
                this.form.dcctl = tierData.dcctl.toFixed(2);
                this.form.hdnca = tierData.hdnca;
                this.form.dnca = tierData.dnca.toFixed(2);
                // this.form.issl = tierData.issl;
                this.form.ssl = tierData.ssl.toFixed(2);
                this.form.hsmtl = tierData.hsmtl;
                this.form.smtl = tierData.smtl.toFixed(2);
                this.form.hswtl = tierData.hswtl;
                this.form.swtl = tierData.swtl.toFixed(2);
                this.form.hstctl = tierData.hstctl;
                this.form.stctl = tierData.stctl.toFixed(2);
                this.form.hstptl = tierData.hstptl;
                this.form.stptl = tierData.stptl.toFixed(2);
                this.form.hscctl = tierData.hscctl;
                this.form.scctl = tierData.scctl.toFixed(2);
                this.form.hsnca = tierData.hsnca;
                this.form.snca = tierData.snca.toFixed(2);
                // this.form.pfbc = tierData.pfbc;
                this.form.supbc = tierData.supbc;
                this.form.dupbc = tierData.dupbc;
                this.form.pbc = tierData.pbc;
                this.form.sbc = tierData.sbc;
                this.form.dbc = tierData.dbc;
                this.oldpbc = tierData.pbc;
                this.oldsbc = tierData.sbc;
                this.olddbc = tierData.dbc;

                this.$nextTick(() => {
                    this.form.sb = tierData.sb;
                    this.form.db = tierData.db;
                });
            }).catch(() => {});
        } else {
            // Setup Stepper
            this.stepper = new Stepper(document.querySelector('.bs-stepper'));
        }
    },
    data () {
        return {
            'form': {
                'ti': null,
                'tn': null,
                // 'rld': null,
                'esl': null,
                'hemtl': false,
                'emtl': null,
                'hewtl': false,
                'ewtl': null,
                'hetctl': false,
                'etctl': null,
                'hetptl': false,
                'etptl': null,
                'hecctl': false,
                'ecctl': null,
                'henca': false,
                'enca': null,
                'db': false,
                'hfl': false,
                // 'idsl': false,
                'dsl': null,
                'hdmtl': false,
                'dmtl': null,
                'hdwtl': false,
                'dwtl': null,
                'hdtctl': false,
                'dtctl': null,
                'hdtptl': false,
                'dtptl': null,
                'hdcctl': false,
                'dcctl': null,
                'hdnca': false,
                'dnca': null,
                'sb': false,
                // 'issl': false,
                'ssl': null,
                'hsmtl': false,
                'smtl': null,
                'hswtl': false,
                'swtl': null,
                'hstctl': false,
                'stctl': null,
                'hstptl': false,
                'stptl': null,
                'hscctl': false,
                'scctl': null,
                'hsnca': false,
                'snca': null,
                'pfbc': false,
                'supbc': true,
                'dupbc': true,
                'pbc': [],
                'sbc': [],
                'dbc': []
            },
            'isSaving': false,
            'submitMessage': '',
            'submitHasError': false,
            'oldpbc': [],
            'oldsbc': [],
            'olddbc': []
        };
    },
    'methods': {
        async nextStep (step) {
            this.submitHasError = false;
            this.submitMessage = null;
            if (step === 1) {
                var result = await this.$validator.validate('tierName');
                if (!result) {
                    return false;
                }
            }
            if (step === 2) {
                // alert(this.form.pbc);
                if (!this.form.pbc.length) {
                    this.submitHasError = true;
                    this.isSaving = false;
                    this.submitMessage = 'Please set employee benefit. ';
                    return false;
                } else if (this.form.sb && !this.form.supbc && !this.form.sbc.length) {
                    this.submitHasError = true;
                    this.isSaving = false;
                    this.submitMessage = 'Please set spouse benefit. ';
                    return false;
                } else if (this.form.db && !this.form.dupbc && !this.form.dbc.length) {
                    this.submitHasError = true;
                    this.isSaving = false;
                    this.submitMessage = 'Please set dependent benefit. ';
                    return false;
                }
            }
            this.stepper.next();
        },
        previousStep () {
            this.submitHasError = false;
            this.submitMessage = null;
            this.stepper.previous();
        },
        getCoPaymentLabel () {
            return `Co-payment means the amount the amount payable by employee on each clinic transaction. 
            Example: 
            Co-payment: RM 5
            Clinic-bill: RM 50
            Employee pays: RM 5
            Employer pays: RM 45`;
        },
        getTelePrescriptionLabel () {
            return `This is benefit limit of medications prescribed by tele-doctors, delivering by pharmacies. `;
        },
        getFamilyBenefitLabel () {
            return `Employee and their family members who entitled outpatient benefits, are subjected to joint annual limit setting by employer.`;
        },
        validateTierForm () {
            return this.$validator.validateAll('tier');
        },
        saveChanges () {
            this.validateTierForm().then((isValid) => {
                if (isValid) {
                    let tempData = JSON.parse(JSON.stringify(this.form));
                    // tempData.rld = convertDateToIso8601(tempData.rld);
                    tempData.esl = tempData.esl ? tempData.esl : 0;

                    this.submitHasError = false;
                    this.isSaving = true;
                    this.submitMessage = 'Saving tier details...';
                    this.axios.post('Tier/SaveTierDetails', tempData)
                        .then(() => {
                            this.submitMessage = 'Tier details saved!';
                            this.$router.push(
                                {
                                    'name': 'tier-list'
                                });
                        }).catch((error) => {
                            this.submitHasError = true;

                            if (error.response && error.response.data) {
                                this.submitMessage = error.response.data.message;
                            } else {
                                this.submitMessage = 'Error saving tier details... Please try again.';
                            }
                        }).finally(() => {
                            this.isSaving = false;
                        });
                }
            });
        },
        showCoverage (relationshipType) {
            switch (relationshipType) {
            case 0:
                this.$refs.popupModalPrincipalCoverage.show();
                break;
            case 1:
                this.$refs.popupModalSpouseCoverage.show();
                break;
            case 2:
                this.$refs.popupModalDependentCoverage.show();
                break;
            }
        },
        cancelCoverage (relationshipType) {
            switch (relationshipType) {
            case 0:
                this.form.pbc = this.isAddTier ? [] : _.cloneDeep(this.oldpbc);
                this.$refs.popupModalPrincipalCoverage.hide();
                break;
            case 1:
                this.form.sbc = this.isAddTier ? [] : _.cloneDeep(this.oldsbc);
                this.$refs.popupModalSpouseCoverage.hide();
                break;
            case 2:
                this.form.dbc = this.isAddTier ? [] : _.cloneDeep(this.olddbc);
                this.$refs.popupModalDependentCoverage.hide();
                break;
            }
        }
    },
    'watch': {
        'form.hfl': function (value) {
            this.form.sb = value;
            this.form.db = value;
        }
    }
};

</script>

<style scoped>
.active .bs-stepper-circle {
    background-color: #009344;
}

.bs-stepper .step-trigger:focus {
  color: #009344;
  outline: none;
}
</style>
